import { render, staticRenderFns } from "./AnnotationCommentsModal.vue?vue&type=template&id=247c3e58&scoped=true&"
import script from "./AnnotationCommentsModal.vue?vue&type=script&lang=js&"
export * from "./AnnotationCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCommentsModal.vue?vue&type=style&index=0&id=247c3e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c3e58",
  null
  
)

export default component.exports